import { InternalAxiosRequestConfig } from 'axios'

import { getAuthToken } from '@/utils/auth/tokenManager'
import { logger } from '@/utils/logger'

export const requestSuccessInterceptor = (config: InternalAxiosRequestConfig) => {
    const token = getAuthToken('access')

    // Debug logging for auth requests
    if (config.url?.includes('/auth/')) {
        logger.debug('[Request Interceptor]', {
            url: config.url,
            hasToken: !!token,
            tokenLength: token?.length || 0,
        })
    }

    if (token) {
        // Use Bearer prefix to align with backend auth expectations
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}

export const requestFailureInterceptor = (error: unknown) => {
    return Promise.reject(error)
}
